import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import assessmentsSlice from "./slices/assessments";

export default function createStore() {
	const store = configureStore({
		reducer: {
			[assessmentsSlice.reducerPath]: assessmentsSlice.reducer,
		},
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(assessmentsSlice.middleware),
	});
	setupListeners(store.dispatch);
	return store;
}

export type Store = ReturnType<typeof createStore>;
export type RootState = ReturnType<Store["getState"]>;
